<template>
  <div :class="['sensors-mic-root', { 'sensors-mic-root--nav-card': navCard }]">
    <a class="card-button" @click="changeBarnTarget(barn, batch, sensors, '/batch-details/smart-mic')">
      <div title="Média de Tosses de ontem " v-bind:class="smartMicColor">
        <div
          class="progress-bar progress"
          role="progressbar"
          :style="navCard ? undefined : 'width: 100%; padding: 0; margin: 0 2px; border-radius: 4px'"
        > 
          <AnimadePlaceHolder v-if="dataMic.length == 0" :height="navCard ? '72px' : '70px'" width="100%" :borderRadius="navCard ? '0' : '4px'"/>
          <div class="container-information-td feed-data-info-col" v-else>
            <div class="feed-data-name-container">
              <p class="product-information-line">
                <span>{{ coughsCount }}</span>
              </p>
              <p class="product-information-line" v-if="smartMicDateTime">
                <span>{{ smartMicDateTime }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import { apiRoutes } from "../utils/api"
import { pickSmartMicSensor, smartMicSensorKey } from "../utils/smartmic"
import AnimadePlaceHolder from './AnimadePlaceHolder.vue'
import { format, parseISO } from 'date-fns'
export default {
  name: "SensorsMic",
  components: {
    AnimadePlaceHolder
  },
  data() {
    return {
        loading: true,
        fetchGen: 0,
    }
  },
  props: ["sensors", "indexBarn", 'barn', 'batch', 'navCard'],
  methods: {
    async getDataMic() {
      const element = pickSmartMicSensor(this.sensors)
      if (!element?.pk) {
        this.loading = false
        return
      }
      const gen = ++this.fetchGen
      try {
        this.$store.commit('incrementActiveRequests');
        const response = await fetch(apiRoutes.smartMicHome(element.pk), {
            headers: this.$store.getters.getHeader
        });
        const json = await response.json();
        if (gen !== this.fetchGen) return

        this.$store.commit('setSensorsListMic', {
          batch: this.batch[0],
          barn: this.barn,
          sensor: this.sensors,
          data: [json]
        })
      } finally {
        if (gen === this.fetchGen) this.loading = false
        this.$store.commit('decrementActiveRequests');
      }
      this.$store.commit('updateStateByBarn', {pk: this.barn.pk, sensor: 'smartmic'})
    },
    changeBarnTarget(barn, batch, sensors, route) {
      if (this.dataMic.length > 0) {
        this.$store.commit("setBarnTarget", barn)
        this.$store.commit("setBatchTarget", batch[0] == undefined ? null : batch[0])
        this.$router.push(route)
      } 
    },
    formatDate(date) {
      if (!date) return null;
      try {
        return format(parseISO(date), 'dd-MM-yyyy HH:mm');
      } catch {
        try {
          return format(new Date(date), 'dd-MM-yyyy HH:mm');
        } catch {
          return null;
        }
      }
    },
  },
  computed: {
    smartMicDateTime() {
      if (typeof this.coughsCount === 'string') return null;
      const rawDate = this.dataMic[0]?.datetime_last_ping
        || this.dataMic[0]?.datetime_fetched
        || this.dataMic[0]?.datetime;
      return this.formatDate(rawDate);
    },
    smartMicColor() {
      if (this.coughsCount === "SEM DADOS") return 'disable progress '
      if (this.coughsCount === "SEM LOTE") return 'disable progress '
      const sum = this.coughsCount/8

      if (sum >= 16) {
        return 'peso-atual-ruim progress '
      }
      if (sum >= 8)  {
        return 'peso-atual-medio progress '
      }
      if (sum < 8) {
        return 'peso-atual-bom progress '
      }
      return 'disable progress '
    },
    coughsCount() {
      if (this.batch[0]?.date_departure != null) return "SEM LOTE"
      if (this.dataMic.length > 0) {
        return this.dataMic[0].message !== undefined ? 'SEM DADOS' :this.dataMic[0].last_coughs_count
      }
      return 'SEM DADOS'
    },
    userRole() {
      return this.$store.getters.getCurrentUser.role
    },
    stateLoadingBarn(){
      return this.$store.getters.getStateBarns.find((barn)=>{
        return barn?.pk == this.barn?.pk
      })
    },
    getDataMicSave() {
      return this.$store.getters.getSensorsListMic
    },
    selectSensorMic() {
      return this.$store.getters.getSensorsListMic.find(obj => obj.batch?.pk == this.batch[0]?.pk)
    },
    dataMic() {
      return this.selectSensorMic?.data ?? []
    },
    micSensorKey() {
      return smartMicSensorKey(this.sensors)
    },
  },
  watch: {
    micSensorKey(next, prev) {
      if (!next || next === prev) return
      this.getDataMic()
    },
  },
  
  async created() {
    const targetPk = pickSmartMicSensor(this.sensors)?.pk
    const storedPk = pickSmartMicSensor(this.selectSensorMic?.sensor)?.pk
    const sameSensor = targetPk != null && String(storedPk) === String(targetPk)
    if (this.dataMic.length == 0 || !sameSensor) {
      await this.getDataMic()
    }
  }
};
</script>

<style scoped>
.cursor{
  cursor: not-allowed;
}
.progress {
  border-radius: 0;
  height: 70px;
  background-color: #f4f4f4;
  font-weight: bold;
  font-size: 14px;
}

.progress-bar {
  text-align: center;
  padding: 0;
}

a {text-decoration: none;}
.peso-atual-acima .progress-bar { background: #415430; color: #fff; }
a .peso-atual-acima .progress-bar:hover { background: #273619; }
.peso-atual-bom .progress-bar { background: #a1cd7b; color: #fff; }
a .peso-atual-bom .progress-bar:hover { background: #5e7d42; }
.peso-atual-medio .progress-bar { background: #e2bf65; color: #fff; }
a .peso-atual-medio .progress-bar:hover { background: #c59e3a; }
.peso-atual-ruim .progress-bar { background: #a94949; color: #fff; }
a .peso-atual-ruim .progress-bar:hover { background: #952323; }
.no-sensor .progress-bar { background: #f2f2f2; color: grey; }
a .no-sensor .progress-bar:hover { background: #cfcfcf; }
.disable .progress-bar { background: #adadad; color: #fff; }
a .disable .progress-bar:hover { background: grey; }


.mic-data {
  transition: transform 0.3s cubic-bezier(0, 0, 0.2, 1); 

}

.mic-data:hover {
  animation: scaleAnimationMic 0.3s ease-in-out 25ms forwards;
}

@keyframes scaleAnimationMic {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.3);

  }
}

.container-information-td.feed-data-info-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 0;
}

.feed-data-name-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.product-information-line {
  margin: 0;
  padding: 0;
  font-size: 14px;
  font-weight: 400;
  color: inherit;
  line-height: 1.5;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  text-align: center;
}

.product-information-line span {
  font-weight: 600;
  margin-left: 0;
}

.card-button {
  cursor: pointer;
}

.sensors-mic-root--nav-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.sensors-mic-root--nav-card .card-button {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 72px;
}

.sensors-mic-root--nav-card .card-button > div {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.sensors-mic-root--nav-card .progress {
  flex: 1;
  width: 100%;
  min-height: 72px;
  height: 100%;
  border-radius: 0;
  margin: 0;
}

.sensors-mic-root--nav-card .progress-bar {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sensors-mic-root--nav-card .container-information-td {
  width: 100%;
  height: 100%;
}

.sensors-mic-root--nav-card .product-information-line {
  font-size: 14px;
  justify-content: center;
  text-align: center;
}
</style>